/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './expressive-modal';
import './expressive-modal-body';
import './expressive-modal-close-button';
import './expressive-modal-footer';
import './expressive-modal-header';
import './expressive-modal-heading';
